import React, { useContext, createContext, useState } from 'react';

const HintContext = createContext();

export function HintProvider({ children }) {
  const [hints, setHintsArray] = useState([]);
  const [step, stepCounter] = useState(1);
  const [totalRoundsNumber, setTotalRoundsNumber] = useState(0);
  const [active, setActive] = useState(false);
  const [startTimer, timerHandler] = useState(false);
  const [timerOnPauseState, setTimerOnPauseState] = useState('');
  const [login, setuseHintLogin] = useState('')

  const handleRoundStep = (newStep, currentTime) => {
    // test if localstorage is available
    function lsTest() {
      const test = 'test';
      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (e) {
        return false;
      }
    }

    if (lsTest() === true) {
       localStorage.setItem(`HUISARREST_ROUND_${login}`, newStep)
       localStorage.setItem(`HUISARREST_MAINTIMER_${login}`, currentTime)
      if (newStep > totalRoundsNumber) {
        // remove localstorage when reaching the final round. So the player can start from the beginning.
        localStorage.removeItem(`HUISARREST_ROUND_${login}`);
        localStorage.removeItem(`HUISARREST_MAINTIMER_${login}`);
        stepCounter(5)
        timerHandler(!startTimer)
      } else {
        return null
      }
    } else {
      if (newStep > totalRoundsNumber) {
        stepCounter(5)
        timerHandler(!startTimer)
      } else {
        return null
      }
    }
  }

  return <HintContext.Provider value={{
    hints,
    stepCounter,
    step,
    totalRoundsNumber,
    setTotalRoundsNumber,
    handleRoundStep,
    active,
    setActive,
    startTimer,
    timerHandler,
    setTimerOnPauseState,
    timerOnPauseState,
    setuseHintLogin,
  }}>
  {children}
  </HintContext.Provider>
}

export const useHint = () => useContext(HintContext);